
var sprite = require("/opt/build/repo/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 8 17.97\" id=\"arrow-right\" ><defs/><title>arrow-right</title><g id=\"arrow-right_Layer_2\" data-name=\"Layer 2\"><g id=\"arrow-right_Icons\"><path class=\"cls-1\" d=\"M8 8.98l-6.6 8.99L0 16.9l5.62-7.92L0 1.03 1.4 0 8 8.98z\" id=\"arrow-right_arrow-right\"/></g></g></symbol>";
module.exports = sprite.add(image, "arrow-right");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-right.svg
// module id = 645
// module chunks = 1474